import React, { useState } from 'react'
import { useEffect } from 'react'
import { getTopic, getExportRequests } from '../../../services/admin'
import Pagination from '../../../components/tablePagination';
import Checkbox from '../Subcomponents/checkbox';
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from 'moment';
import "./index.css"
import { toast } from "react-toastify";

export default function Exports() {
    const [list, setList] = useState([]);
    const [totalcount, setTotalCount] = useState(0);
    const [timezonePage, settimezonePage] = useState(1);
    const [timezonerowsPerPage, settimezonerowsPerPage] = useState(25);
    const navigate = useNavigate();
    const [topic, setTopic] = useState("");
    const [status, setStatus] = useState("Add");
    const [topicId, setTopicId] = useState("");



    useEffect(() => {
        let info = {
            page: timezonePage, rowsPerPage: timezonerowsPerPage
        }
        getRecord(info);
    }, [])
    const getPaginationData = (data) => {
        let info = {
            page: data.page, rowsPerPage: data.rowsPerPage
        }
        getRecord(info);
    }

    const getRecord = (info) => {
        getExportRequests(info).then((data) => {
            if (data.data.status) {
                setList(data.data.data.data)
                setTotalCount(data.data.data.total)
            }
        }).catch(() => { })
    }

    const navigateEdit = (e, id) => {
        window.renderFirst = false;
        if (e.target.className == "capitalizeMedium") {
            navigate(`/edit/${id.user_id}`);
        }
    };




    return (

        <>

            <div className="table-box-medium">
                <table className="caseTable">
                    <tbody>
                        <tr className="dark">

                            <th>
                                {" "}
                                <div className="d-flex align-items-center">
                                    {" "}
                                    <span className="scren-name">ID</span>{" "}
                                    {/* <Sorting callApi={filterListMediums} /> */}
                                </div>
                            </th>

                            <th>Export Type</th>
                            <th>Status</th>
                            <th>Created</th>
                            <th>Created by</th>
                            <th>Action</th>
                        </tr>
                        {list.length > 0 ? (
                            list.map((data) => (
                                <tr
                                    className="innr pointer"
                                >


                                    <td className='capitalizeMedium'>{
                                        data.id
                                    }
                                    </td>
                                    <td className='export-td'>
                                        {data.export_type}
                                    </td>
                                    <td className='export-td'>
                                        {data.export_status == 1 ? "Completed" : "   Pending"}
                                    </td>
                                    <td className='export-td'>
                                        {data.created_at ? moment(data.created_at).format("DD-MM-YYYY hh:mm A") : ""}
                                    </td>
                                    <td className='export-td'>
                                        {data.user
                                        ? (data.user.screen_name && data.user.screen_name.trim() !== ""
                                            ? data.user.screen_name
                                            : data.user.first_name)
                                        : "-"}
                                    </td>
                                    <td className='export-td'>
                                        <div>
                                            {data.export_status == 1 ? (
                                                <a
                                                    className="export-btn topic-btn"
                                                    href={data.export_file_name}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Exports
                                                </a>
                                            ) : (
                                                <span>-</span>
                                            )}

                                            &nbsp;


                                        </div>

                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={6} className="text-center export-td" >
                                    No Records Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>



            </div>

            <Pagination
                rowsPerPageOptions={[25, 50, 100]}
                count={totalcount}
                activeTab={"admindetectedTimezones"}
                timezonePage={timezonePage}
                timezonerowsPerPage={timezonerowsPerPage}
                getPaginationData={getPaginationData}
            />



        </>
    )
}
